var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex flex-col py-6",
      staticStyle: { "min-width": "600px" }
    },
    [
      _c("div", { staticClass: "w-full" }, [
        _c("div", { staticClass: "flex flex-col" }, [
          _c("div", { staticClass: "flex flex-col items-center mb-6" }, [
            _c("div", { staticClass: "px-4 mb-6" }, [
              _c("img", {
                staticClass:
                  "shadow rounded max-w-full h-auto align-middle border-none",
                staticStyle: { width: "150px" },
                attrs: {
                  alt: "...",
                  src: !!_vm.user_edit.avatar
                    ? _vm.user_edit.avatar
                    : _vm.imgPlaceholder
                }
              })
            ]),
            _vm._v(" "),
            _vm.isEdit
              ? _c("div", { staticClass: "flex flex-col mb-2" }, [
                  _c("p", { staticClass: "text-xs text-gray-700" }, [
                    _vm._v("Minimum 900x900, Maximum 1MB")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isFileLarge || _vm.isErrorImage
              ? _c(
                  "div",
                  { staticClass: "flex flex-col mb-2" },
                  [
                    _vm.isFileLarge
                      ? _c("text-error", {
                          attrs: { text: "Please select correct file" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isErrorImage
                      ? _c("text-error", {
                          attrs: { text: "Image is Required." }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex" },
              [
                !_vm.user_edit.avatar && _vm.isEdit
                  ? _c("Button", {
                      attrs: { label: "Browse File" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "any",
                            fn: function() {
                              return [
                                _c("input", {
                                  staticStyle: {
                                    width: "100%",
                                    height: "100%",
                                    position: "absolute",
                                    left: "0",
                                    top: "0",
                                    opacity: "0",
                                    cursor: "pointer",
                                    "z-index": "2"
                                  },
                                  attrs: {
                                    type: "file",
                                    name: "profile_picture"
                                  },
                                  on: { change: _vm.onFileChange }
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        2462335240
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.user_edit.avatar && _vm.isEdit
                  ? _c("Button", {
                      attrs: { label: "Cancel", variant: "default" },
                      on: { clicked: _vm.changeImage }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex w-full" }, [
        _c(
          "div",
          { staticClass: "w-1/2" },
          [
            _c("form-item", {
              attrs: { label: "Full Name" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _vm.isEdit
                        ? [
                            _c("Input", {
                              attrs: {
                                placeholder: "Full Name",
                                error:
                                  _vm.$v.user_edit.name.$dirty &&
                                  !_vm.$v.name.required
                              },
                              model: {
                                value: _vm.user_edit.name,
                                callback: function($$v) {
                                  _vm.$set(_vm.user_edit, "name", $$v)
                                },
                                expression: "user_edit.name"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex flex-col pt-2" },
                              [
                                _vm.$v.user_edit.name.$dirty &&
                                !_vm.$v.user_edit.name.required
                                  ? _c("text-error", {
                                      attrs: { text: "Please fill your name." }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        : _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(_vm._s(_vm.user.name))
                          ])
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Email" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _vm.isEdit
                        ? [
                            _c("Input", {
                              attrs: {
                                placeholder: "Email",
                                error:
                                  _vm.$v.user_edit.email.$dirty &&
                                  (!_vm.$v.user_edit.email.required ||
                                    !_vm.$v.user_edit.email.email)
                              },
                              model: {
                                value: _vm.user_edit.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.user_edit, "email", $$v)
                                },
                                expression: "user_edit.email"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex flex-col pt-2" },
                              [
                                _vm.$v.user_edit.email.$dirty &&
                                !_vm.$v.user_edit.email.required
                                  ? _c("text-error", {
                                      attrs: { text: "Please fill your name." }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$v.user_edit.email.$dirty &&
                                !_vm.$v.user_edit.email.email
                                  ? _c("text-error", {
                                      attrs: { text: "Email is not valid." }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        : _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(_vm._s(_vm.user.email))
                          ])
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Birthdate" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _vm.isEdit
                        ? [
                            _c("Input", {
                              attrs: { placeholder: "Birthdate" },
                              model: {
                                value: _vm.user_edit.dob,
                                callback: function($$v) {
                                  _vm.$set(_vm.user_edit, "dob", $$v)
                                },
                                expression: "user_edit.dob"
                              }
                            })
                          ]
                        : _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(_vm._s(_vm.user.dob || "-"))
                          ])
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Email" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _vm.isEdit
                        ? [
                            _c("Input", {
                              attrs: {
                                placeholder: "Email",
                                error:
                                  _vm.$v.user_edit.email.$dirty &&
                                  (!_vm.$v.user_edit.email.required ||
                                    !_vm.$v.user_edit.email.email)
                              },
                              model: {
                                value: _vm.user_edit.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.user_edit, "email", $$v)
                                },
                                expression: "user_edit.email"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex flex-col pt-2" },
                              [
                                _vm.$v.user_edit.email.$dirty &&
                                !_vm.$v.user_edit.email.required
                                  ? _c("text-error", {
                                      attrs: { text: "Please fill your name." }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$v.user_edit.email.$dirty &&
                                !_vm.$v.user_edit.email.email
                                  ? _c("text-error", {
                                      attrs: { text: "Email is not valid." }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        : _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(_vm._s(_vm.user.email))
                          ])
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Bio" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _vm.isEdit
                        ? [
                            _c(
                              "div",
                              { staticClass: "relative" },
                              [
                                _c("TextArea", {
                                  attrs: {
                                    placeholder: "Tell us about you",
                                    error:
                                      _vm.$v.user_edit.bio.$dirty &&
                                      !_vm.$v.user_edit.bio.maxLength,
                                    maxlength: _vm.bioMaxLength,
                                    rows: "10"
                                  },
                                  model: {
                                    value: _vm.user_edit.bio,
                                    callback: function($$v) {
                                      _vm.$set(_vm.user_edit, "bio", $$v)
                                    },
                                    expression: "user_edit.bio"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "absolute right-0 text-xs",
                                    staticStyle: {
                                      bottom: "15px",
                                      right: "15px"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.user_edit.bio.length) +
                                        "/" +
                                        _vm._s(_vm.bioMaxLength)
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex flex-col pt-2" },
                              [
                                _vm.$v.user_edit.bio.$dirty &&
                                !_vm.$v.user_edit.bio.maxLength
                                  ? _c("text-error", {
                                      attrs: {
                                        text:
                                          "Maximum character for bio is 2000 characters."
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        : _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(
                              _vm._s(
                                _vm.user.bio_status == 1
                                  ? _vm.user.biodata || "-"
                                  : _vm.user.bio
                              )
                            )
                          ])
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            !_vm.isEdit
              ? _c("form-item", {
                  attrs: { label: "Bio Status" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function() {
                          return [
                            _c("div", { staticClass: "text-left" }, [
                              _vm.user.bio_status == 1 ||
                              (_vm.user.bio_status == 0 && _vm.user.bio != null)
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-xs text-center font-semibold inline-block py-1 px-2 uppercase rounded uppercase last:mr-0 mr-1 w-64",
                                      class:
                                        _vm.user.bio_status == 1
                                          ? "text-green-600 bg-green-200"
                                          : "text-orange-600 bg-orange-200"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.user.bio_status == 1
                                            ? "Published"
                                            : "Waiting for Review"
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    2428007299
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Language" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _vm.isEdit
                        ? [
                            _c(
                              "el-select",
                              {
                                staticClass: "w-full",
                                attrs: {
                                  filterable: "",
                                  placeholder: "Select Language"
                                },
                                model: {
                                  value: _vm.user_edit.language,
                                  callback: function($$v) {
                                    _vm.$set(_vm.user_edit, "language", $$v)
                                  },
                                  expression: "user_edit.language"
                                }
                              },
                              _vm._l(_vm.dataLanguages, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex flex-col pt-2" },
                              [
                                _vm.$v.user_edit.language.$dirty &&
                                !_vm.$v.user_edit.language.required
                                  ? _c("text-error", {
                                      attrs: { text: "Please choose language." }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        : _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(_vm._s(_vm.getLanguageLabel()))
                          ])
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _vm.isEdit
              ? _c("form-item", {
                  attrs: { label: "Password" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function() {
                          return [
                            _c(
                              "div",
                              { staticClass: "relative" },
                              [
                                _c("Input", {
                                  attrs: {
                                    type: _vm.showPassword
                                      ? "text"
                                      : "password",
                                    placeholder: "Password"
                                  },
                                  model: {
                                    value: _vm.user_edit.password,
                                    callback: function($$v) {
                                      _vm.$set(_vm.user_edit, "password", $$v)
                                    },
                                    expression: "user_edit.password"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "absolute top-0 right-0 mr-2 mt-3 ",
                                    staticStyle: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        _vm.showPassword = !_vm.showPassword
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa",
                                      class: _vm.showPassword
                                        ? "fa-eye-slash"
                                        : "fa-eye"
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    2288676503
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Upload File Agreement" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _vm.isEdit
                        ? [
                            _c("div", { staticClass: "flex-1" }, [
                              !_vm.user_edit.file_agreement
                                ? _c("input", {
                                    staticClass:
                                      "block border border-grey-light w-full p-3 rounded",
                                    attrs: {
                                      type: "file",
                                      name: "file_agreement",
                                      accept: "application/pdf"
                                    },
                                    on: { change: _vm.onFileChangeAgreement }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.user_edit.file_agreement
                                ? _c("div", { staticClass: "flex" }, [
                                    _vm.user.file_agreement ==
                                    _vm.user_edit.file_agreement
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "underline font-bold mr-2",
                                            attrs: {
                                              href: _vm.user.file_agreement,
                                              target: "_blank"
                                            }
                                          },
                                          [_vm._v("Agreement Link")]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticClass:
                                              "mr-2 text-gray-700 font-medium"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.user_edit
                                                  .file_agreement_name
                                              )
                                            )
                                          ]
                                        ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "cursor-pointer",
                                        on: { click: _vm.changeFileAgreement }
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: {
                                            icon: ["fas", "times-circle"]
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ]
                        : _c("p", { staticClass: "text-left" }, [
                            _vm.user.file_agreement
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "underline font-bold mr-2",
                                    attrs: {
                                      href: _vm.user.file_agreement,
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._v("Agreement Link")]
                                )
                              : _c("span", [_vm._v("-")])
                          ])
                    ]
                  },
                  proxy: true
                }
              ])
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "w-1/2" },
          [
            _c("form-item", {
              attrs: { label: "Bank Name" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _vm.isEdit
                        ? [
                            _c("Input", {
                              attrs: {
                                placeholder: "Bank Name",
                                error:
                                  _vm.$v.user_edit.bank.bank.$dirty &&
                                  !_vm.$v.user_edit.bank.bank.required
                              },
                              model: {
                                value: _vm.user_edit.bank.bank,
                                callback: function($$v) {
                                  _vm.$set(_vm.user_edit.bank, "bank", $$v)
                                },
                                expression: "user_edit.bank.bank"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex flex-col pt-2" },
                              [
                                _vm.$v.user_edit.bank.bank.$dirty &&
                                !_vm.$v.user_edit.bank.bank.required &&
                                _vm.showErrorBank
                                  ? _c("text-error", {
                                      attrs: {
                                        text: "Bank Name must be filled."
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        : _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(_vm._s(_vm.user.bank.bank || "-"))
                          ])
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Account Name" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _vm.isEdit
                        ? [
                            _c("Input", {
                              attrs: {
                                placeholder: "Account Name",
                                error:
                                  _vm.$v.user_edit.bank.account_name.$dirty &&
                                  !_vm.$v.user_edit.bank.account_name.required
                              },
                              model: {
                                value: _vm.user_edit.bank.account_name,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.user_edit.bank,
                                    "account_name",
                                    $$v
                                  )
                                },
                                expression: "user_edit.bank.account_name"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex flex-col pt-2" },
                              [
                                _vm.$v.user_edit.bank.account_name.$dirty &&
                                !_vm.$v.user_edit.bank.account_name.required &&
                                _vm.showErrorBank
                                  ? _c("text-error", {
                                      attrs: {
                                        text: "Account Name must be filled."
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        : _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(_vm._s(_vm.user.bank.account_name || "-"))
                          ])
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Account Number" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _vm.isEdit
                        ? [
                            _c("Input", {
                              attrs: {
                                placeholder: "Account Number",
                                error:
                                  _vm.$v.user_edit.bank.account_number.$dirty &&
                                  (!_vm.$v.user_edit.bank.account_number
                                    .required ||
                                    !_vm.$v.user_edit.bank.account_number
                                      .numeric)
                              },
                              model: {
                                value: _vm.user_edit.bank.account_number,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.user_edit.bank,
                                    "account_number",
                                    $$v
                                  )
                                },
                                expression: "user_edit.bank.account_number"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex flex-col pt-2" },
                              [
                                _vm.$v.user_edit.bank.account_number.$dirty &&
                                !_vm.$v.user_edit.bank.account_number
                                  .required &&
                                _vm.showErrorBank
                                  ? _c("text-error", {
                                      attrs: {
                                        text: "Account Number must be filled."
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$v.user_edit.bank.account_number.$dirty &&
                                !_vm.$v.user_edit.bank.account_number.numeric &&
                                _vm.showErrorBank
                                  ? _c("text-error", {
                                      attrs: { text: "Must be numeric." }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        : _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(_vm._s(_vm.user.bank.account_number || "-"))
                          ])
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Swift Code" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _vm.isEdit
                        ? [
                            _c("Input", {
                              attrs: {
                                placeholder: "Swift Code",
                                error:
                                  _vm.$v.user_edit.bank.swift_code.$dirty &&
                                  !_vm.$v.user_edit.bank.swift_code.required
                              },
                              model: {
                                value: _vm.user_edit.bank.swift_code,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.user_edit.bank,
                                    "swift_code",
                                    $$v
                                  )
                                },
                                expression: "user_edit.bank.swift_code"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex flex-col pt-2" },
                              [
                                _vm.$v.user_edit.bank.swift_code.$dirty &&
                                !_vm.$v.user_edit.bank.swift_code.required &&
                                _vm.showErrorBank
                                  ? _c("text-error", {
                                      attrs: {
                                        text: "Account Number must be filled."
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        : _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(_vm._s(_vm.user.bank.swift_code || "-"))
                          ])
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Wise ID (Wisetag)" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _vm.isEdit
                        ? [
                            _c("Input", {
                              attrs: { placeholder: "e.g. @elianab210" },
                              model: {
                                value: _vm.user_edit.wise.handle,
                                callback: function($$v) {
                                  _vm.$set(_vm.user_edit.wise, "handle", $$v)
                                },
                                expression: "user_edit.wise.handle"
                              }
                            })
                          ]
                        : _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(_vm._s(_vm.wiseAccount.handle || "-"))
                          ])
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Total Earning" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _c("p", { staticClass: "text-left font-bold" }, [
                        _vm._v(
                          "$" +
                            _vm._s(parseFloat(_vm.user.earning).toFixed(2) || 0)
                        )
                      ])
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Balance" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _c("p", { staticClass: "text-left font-bold" }, [
                        _vm._v(
                          "$" +
                            _vm._s(parseFloat(_vm.user.balance).toFixed(2) || 0)
                        )
                      ])
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "MusicVerse Cut" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _vm.isEdit
                        ? [
                            _c("Input", {
                              attrs: {
                                placeholder: "Account Number",
                                error:
                                  _vm.$v.user_edit.musicverse_cut.$dirty &&
                                  (!_vm.$v.user_edit.musicverse_cut.required ||
                                    !_vm.$v.user_edit.musicverse_cut.numeric)
                              },
                              model: {
                                value: _vm.user_edit.musicverse_cut,
                                callback: function($$v) {
                                  _vm.$set(_vm.user_edit, "musicverse_cut", $$v)
                                },
                                expression: "user_edit.musicverse_cut"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex flex-col pt-2" },
                              [
                                _vm.$v.user_edit.musicverse_cut.$dirty &&
                                !_vm.$v.user_edit.musicverse_cut.required
                                  ? _c("text-error", {
                                      attrs: {
                                        text: "MusicVerse Cut must be filled."
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$v.user_edit.musicverse_cut.$dirty &&
                                !_vm.$v.user_edit.musicverse_cut.numeric
                                  ? _c("text-error", {
                                      attrs: { text: "Must be numeric." }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        : _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(_vm._s(_vm.user.musicverse_cut || "-"))
                          ])
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Artist Cut" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _vm.isEdit
                        ? [
                            _c("Input", {
                              attrs: {
                                placeholder: "Account Number",
                                error:
                                  _vm.$v.user_edit.artist_cut.$dirty &&
                                  (!_vm.$v.user_edit.artist_cut.required ||
                                    !_vm.$v.user_edit.artist_cut.numeric)
                              },
                              model: {
                                value: _vm.user_edit.artist_cut,
                                callback: function($$v) {
                                  _vm.$set(_vm.user_edit, "artist_cut", $$v)
                                },
                                expression: "user_edit.artist_cut"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex flex-col pt-2" },
                              [
                                _vm.$v.user_edit.artist_cut.$dirty &&
                                !_vm.$v.user_edit.artist_cut.required
                                  ? _c("text-error", {
                                      attrs: {
                                        text: "Artist Cut must be filled."
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$v.user_edit.artist_cut.$dirty &&
                                !_vm.$v.user_edit.artist_cut.numeric
                                  ? _c("text-error", {
                                      attrs: { text: "Must be numeric." }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        : _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(_vm._s(_vm.user.artist_cut || "-"))
                          ])
                    ]
                  },
                  proxy: true
                }
              ])
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex flex-col md:flex-row mt-4 pt-4 border-t" },
        [
          _vm.isEdit && !_vm.isReviewing
            ? _c("Button", {
                attrs: { label: "Save" },
                on: { clicked: _vm.save }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isReviewing
            ? _c("Button", {
                attrs: { label: _vm.isEdit ? "Save and Publish" : "Publish" },
                on: { clicked: _vm.publish }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("Button", {
            attrs: { variant: "default", label: _vm.labelToggleEdit },
            on: { clicked: _vm.toggleEdit }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e0d895b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e0d895b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ArtistContent/ArtistProfile.vue
// module id = null
// module chunks = 